import { Box, IconButton } from "@mui/material";
import DataTable from "app/components/DataTable";
import { DownloadIcon, FileTextIcon, ViewIcon } from "app/icons";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { CustomerDocument } from "../../../types";
import { useStyles } from "./styles";

type Props = {
  rows: CustomerDocument[];
};

const Document = ({ rows }: Props) => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();

  const columns = useMemo(
    () => [
      {
        id: "actions",
        label: "",
        minWidth: 100,
        align: "left",
        format: (row: CustomerDocument) => (
          <Box className={styles.actionsCell}>
            <IconButton
              className={styles.downloadButton}
              onClick={() => console.log("download", row.id)}
              aria-label={t("CUSTOMERS.DETAILS.DOCUMENTS.TABLE.DOWNLOAD")}
            >
              <DownloadIcon width={24} height={24} />
            </IconButton>
            <IconButton
              className={styles.viewButton}
              onClick={() => console.log("view", row.id)}
              aria-label={t("CUSTOMERS.DETAILS.DOCUMENTS.TABLE.VIEW")}
            >
              <ViewIcon width={24} height={24} />
            </IconButton>
          </Box>
        ),
      },
      {
        id: "date",
        label: t("CUSTOMERS.DETAILS.DOCUMENTS.TABLE.DATE"),
        minWidth: 100,
        align: "right",
      },
      {
        id: "uploadedBy",
        label: t("CUSTOMERS.DETAILS.DOCUMENTS.TABLE.UPLOADED_BY"),
        minWidth: 140,
        align: "right",
      },
      {
        id: "connectedVehicle",
        label: t("CUSTOMERS.DETAILS.DOCUMENTS.TABLE.VEHICLE"),
        minWidth: 140,
        align: "right",
      },
      {
        id: "documentName",
        label: t("CUSTOMERS.DETAILS.DOCUMENTS.TABLE.DOCUMENT_NAME"),
        minWidth: 180,
        align: "right",
        format: (row: CustomerDocument) => (
          <Box className={styles.documentNameCell}>
            <FileTextIcon width={18} height={18} />
            <span>{row.documentName}</span>
          </Box>
        ),
      },
    ],
    [styles, t]
  );

  return (
    <Box className={styles.root} dir={i18n.dir()}>
      <DataTable
        rows={rows}
        columns={columns}
        serialEnabled={false}
        noDataLabel={t("CUSTOMERS.DETAILS.DOCUMENTS.EMPTY")}
      />
    </Box>
  );
};

export default Document;
